module.exports = __webpack_public_path__ + "img/confirm-icon.13c60d44.gif";